<ng-container sgDocTitle="Not Found"></ng-container>
<div class="page-not-found-container">
  <div class="sg-fill sg-justify-center sg-items-start">
    <span class="sorry-label">SORRY</span>
    <h1 class="mat-display-4" style="letter-spacing: 8px">404</h1>
    <div class="sg-flex-column">
      <h1 translate>NOTFOUND.title</h1>
      <h2 class="sg-dashboard-title" style="max-width: 308px" translate>NOTFOUND.desc</h2>
      <sg-button variant="primary" icon="arrow_back" iconPosition="start" [text]="'NOTFOUND.backHome' | translate" [routerLink]="['/']"></sg-button>
    </div>
  </div>
</div>
